
import {useEffect, useState} from 'react';
import {useAuthContext, useClient} from 'app/gakki/context/auth-context';
import {usePayrollOptions, getData as getParameterSettings, useAccountCategory, useSalaryAccounts} from 'app/gakki/api/payroll';
import {PayrollCompanySetting} from 'app/gakki/api/types';

const defaultParameter = {
  banks: [],
  incomeTaxRegistrationUnits: [],
  insuranceUnits: [],
}

function useSalarySettingOptions() {
  const api = useClient();
  const {companyId} = useAuthContext();
  const [insuranceIdentity, setInsuranceIdentity] = useState<{ item: string, value: string}[]>([])
  const [systemSalarySubject, setSystemSalarySubject] = useState([])
  const [parameter, setParameter] = useState<PayrollCompanySetting>(defaultParameter)
  const [isParameterLoading, setIsParameterLoading] = useState(true)
  const [isInsuranceIdentityLoading, setIsInsuranceIdentityLoading] = useState(true)
  const [isSubjectLoading, setIsSubjectLoading] = useState(true)
  const {data: dependentsExemptionCondition = [], isLoading: isExemptionConditionLoading } = usePayrollOptions('DependentsExemptionCondition');
  const {data: incomeTaxWithholdingTypes = [], isLoading: isIncomeTaxWithholdingTypesLoading } = usePayrollOptions('IncomeTaxWithholdingTypes');
  const {data: incomeTaxNumbers = [], isLoading: isIncomeTaxNumbersLoading } = usePayrollOptions('IncomeTaxNumbers');
  const {data: nHIDependentsAddTitle = [], isLoading: isDependentsAddTitleLoading } = usePayrollOptions('NHIDependentsAddTitle');
  const {data: accountCategory = [], isLoading: isAccountCategoryLoading } = useAccountCategory();
  const {data: salaryAccounts = [], isLoading: isSalaryAccountsLoading, refetch: refetchSalaryAccounts } = useSalaryAccounts();


  useEffect(() => {
    api.get('payroll/hn/insurance/identity').then(d => {
      setInsuranceIdentity(d.data);
    }).finally(() => setIsInsuranceIdentityLoading(false));
    api.get('payroll/hn/salary/account').then(d => {
      setSystemSalarySubject(d.data.filter((a: any) => !/1000|1001|1002/.test(a.code)).sort((a: any, b: any) => a.code - b.code))
    }).finally(() => setIsSubjectLoading(false));
    getParameterSettings(api, companyId).then(d => {
      setParameter(d.data || defaultParameter);
    }).finally(() => setIsParameterLoading(false));
  }, []);

  return {
    isLoading: isExemptionConditionLoading ||
    isIncomeTaxWithholdingTypesLoading ||
    isIncomeTaxNumbersLoading ||
    isDependentsAddTitleLoading ||
    isSubjectLoading ||
    isInsuranceIdentityLoading ||
    isParameterLoading ||
    isAccountCategoryLoading ||
    isSalaryAccountsLoading,
    dependentsExemptionCondition,
    incomeTaxWithholdingTypes,
    incomeTaxNumbers,
    nHIDependentsAddTitle,
    systemSalarySubject,
    insuranceIdentity,
    accountCategory,
    salaryAccounts,
    refetchSalaryAccounts,
    ...parameter,
  };
}

export default useSalarySettingOptions;
